
import React from "react";
// import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";




const ProtectedRoute = ({ isAuthenticated, children, adminRoute }) => {
    const { isLoginLoading, user } = useSelector((state) => state.auth);
    // const { loading, user } = useSelector((state) => state.user);
    // if (!loading && isAuthenticated === false) {
    if (!isLoginLoading && isAuthenticated === false) {
        return <Navigate to="/admin/login" replace />;
    }



    return (

        children ? children : <Outlet />


    );
}


export default ProtectedRoute